export const platformsPageData = {
    navLinks: [
        { to: 'architecting-new-possibilities', label: 'Architecting New Possibilities' },
        { to: 'digital-core-capabilities', label: 'Digital Core Capabilities' },
        { to: 'digital-operating-model', label: 'Digital Operating Model' },
        { to: 'empowering-talent-transformation', label: 'Empowering Talent Transformation' },
        { to: 'tales-of-transformation', label: 'Tales of Transformation' },
    ],
    overview: {
        title: 'Overview',
        paragraphOne: 'In an era defined by rapid technological advancements and shifting market dynamics, the ability to move quickly is crucial for sustained success. This section provides an overview of key strategies and insights that can help businesses navigate the complexities of the digital landscape and position themselves for future growth.',
        paragraphTwo: "From embracing emerging technologies to fostering a culture of innovation, we explore the essential elements that contribute to successful transformation. Discover how to identify new opportunities, mitigate risks, and create a roadmap for your organization's future in this ever-evolving business environment.",
        paragraphThree: "Whether you're a seasoned executive or an aspiring leader, this section offers valuable perspectives and actionable insights to help you move with confidence and agility.",
    },
    platformOptions: [
        { key: 'platformOne', label: 'Platform Logo Placeholder' },
        { key: 'platformTwo', label: 'Platform Logo Placeholder' },
        { key: 'platformThree', label: 'Platform Logo Placeholder' },
    ],
    emptyStateMessage: 'Click on a Platform Logo Placeholder to open component.',
    footerText: 'Platforms Footer',
}
